import Slider from '../../ui/Slider';
import Table from '../../ui/Table';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';

const UploadMultiplePicturesSD = ({ dataTask }) => {
    const titleObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Title'));
    const descriptionObject = dataTask?.task.find((obj) => Object.keys(obj).includes('Description'));
    const bountyTitle = dataTask?.task.find((obj) => Object.keys(obj).includes('bountyTitle'));
   
    // Prepare modal header data
    const modalHeaderData = {
        bountyTitle: dataTask?.bountyTitle || bountyTitle?.bountyTitle || 'Image Preview',
        dataPointTitle: titleObject?.Title || 'Data Point 1',
        dataPointDescription: descriptionObject?.Description || '-',
        responseType: microtaskTypeData.find((ele) => ele.type === dataTask.actionType)?.label || 'File Upload'
    };
   
    console.log(dataTask, bountyTitle, 'see the data task here photos');
    return (
        <Table.Row>
            <p className=" text-textPrimary flex flex-col   ">
                <span className="font-medium mb-1  "> {titleObject?.Title || '-'} </span>
                <span className="text-xs font-medium mb-1">{descriptionObject?.Description || '-'}</span>
            </p>
            <p className="text-sm justify-self-center">
                {microtaskTypeData.find((ele) => ele.type === dataTask.actionType).label}
            </p>

            {dataTask?.files?.length > 0 ? (
                <div>
                    <Slider 
                        images={dataTask.files} 
                        submissionData={dataTask?.submission} 
                        modalHeaderData={modalHeaderData}
                    />
                </div>
            ) : (
                <span className=" text-textSecondary mb-1 ">Not answered</span>
            )}
        </Table.Row>
    );
};

export default UploadMultiplePicturesSD;
